import React, { useEffect, useState } from 'react';
import './HonoraryEmployeesSlider.scss';
import EmploeesSlideItem from './EmploeesSlideItem';
import img3 from '../../../assets/img/jobs/astashov-vladimir.png';
import img4 from '../../../assets/img/jobs/starkova-alina.png';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const employees = [
  {
    id: 3,
    src: img3,
    name: 'Владимир Асташов',
    info: {
      city: 'Самара',
      experience: '1 год в компании',
      highlightValue: 'За 1 год вырос из официанта в бармена',
    },
    thoughts: `«DOSKI» меня привлекли своей атмосферой и эстетикой, дружным и отзывчивым коллективом, возможностью обучаться основам профессии. Мне нравится работать с коктейлями - создавать новые сочетания. И компания помогает мне развиваться в этом направлении.`
  },
  {
    id: 4,
    src: img4,
    name: 'Алина Старкова',
    info: {
      city: 'Самара',
      experience: '4 года в команде',
      highlightLabel: 'Должность',
      highlightValue: 'Старший менеджер',
    },
    thoughts: `Ценю компанию за возможности карьерного роста, стабильные выплаты, развитие в своей должности и регулярное обучение. Здесь сильная команда, поддержка наставников и комфортная рабочая атмосфера. Профессиональная цель — вырасти в руководителя и взять на себя больше ответственности.`
  },
];

const HonoraryEmployeesSlider = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    // Для loop требуется минимум 3 слайда
    // Если слайдов меньше 3, дублируем их
    if (employees.length < 3) {
      const duplicatedSlides = [...employees];
      // Добавляем слайды, пока не будет минимум 3
      while (duplicatedSlides.length < 3) {
        duplicatedSlides.push(...employees);
      }
      setSlides(duplicatedSlides.slice(0, Math.max(3, employees.length * 2)));
    } else {
      setSlides(employees);
    }
  }, []);


  useEffect(() => {
    if (slides.length < 3) return; // Не инициализируем пока нет минимум 3 слайдов

    const swiper = new Swiper('.swiper-job4', { //тот же класс, что и в разметке

      loop: true,    
      breakpoints: {
        2500: {
          spaceBetween: 18,
          slidesPerView: 1.85,
        },
        2259: {
          spaceBetween: 15,
          slidesPerView: 1.85,
        },
        1280: {
          spaceBetween: 10,
          slidesPerView: 1.85,
        },
        1025: {
          spaceBetween: 10,
          slidesPerView: 1.5,
        },
        860: {
          spaceBetween: 10,
          slidesPerView: 1.34,
        },
        769: {
          spaceBetween: 10,
          slidesPerView: 1.17,
        },
        376: {
          spaceBetween: 16,
          slidesPerView: 1.118,
        },
        0: { 
          spaceBetween: 16,
          slidesPerView: 1.3557, 
        }
        // 1440 1.85    10
        // 1024 1.34    10
        // 768  1.118   16
        // 375  1.3557  16
      },
    
      navigation: { //arrows
        nextEl: '.swiper-button-next-job4',
        prevEl: '.swiper-button-prev-job4',
      },
    });

    return () => {
      swiper.destroy(); // Очистка при размонтировании
    };
  }, [slides]);

  if (slides.length === 0) return null; // или loading



  return (
    <div className="swiper-wrapper-job4">

      <div className="swiper-job4">
        <div className="swiper-wrapper">
          {/* {employees.map((employee, index) => ( */}
          {slides.map((employee, index) => (
              <div className="swiper-slide" key={index}>
                <EmploeesSlideItem employee={employee}/>
              </div>
            ))}
        </div>
      </div>
      <div className='gradient-bg'></div>

      <div className="swiper-button-prev-job4"></div>
      <div className="swiper-button-next-job4"></div>
    </div>
  )
}

export default HonoraryEmployeesSlider;
